export const URLS = {
  archiveDocuments: '/archive/contracts',
  archivePackages: '/archive/packages',
  account: '/account',
  api: '/api',
  contacts: '/companies',
  contracts: '/contracts', // alias for documents
  dataStreamAdd: '/data-streams/add',
  dataStreams: '/data-streams',
  dataTypes: '/data-types',
  defaultQueue: '/default-queue',
  packages: '/packages',
  documents: '/contracts',
  formAdd: '/forms/add',
  forms: '/forms',
  home: '/',
  oauthAzure: '/oauth/azure',
  oauthGoogle: '/oauth/google',
  oauthOkta: '/oauth/okta',
  zealidCallback: '/zealid/callback',
  register: '/register',
  requestPasswordReset: '/reset-password',
  resetPassword: '/reset-password/:token',
  templateAdd: '/templates/add',
  templates: '/templates',
  transactions: '/transactions',
  verifyEmail: '/verify-email',
  devDesignSystem: '/dev/design-system',
  portal: '/portal',
} as const;
